<template>
    <div>
      <overtime-entry-form :item="item" @reloadData="reloadData"></overtime-entry-form>
            <Snackbar :SnackbarVal="SnackbarVal"></Snackbar>        
              <!-- Confirmation delete box -->
        <v-layout row justify-center>
            <v-dialog v-model="confirmModel" max-width="290">
                <v-card>
                    <v-card-text>Are you sure you want to delete this data?</v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="green darken-1" flat="flat" @click.native="confirmModel = false">Disagree</v-btn>
                        <v-btn color="green darken-1" flat="flat" @click.native="confirmDelete(row_index, delete_id)">
                            Agree
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>
        <!-- /Confirmation delete box -->
     <v-container>
 <v-card>
    <v-card-title>
	<span class="headline">Outsourcing Staff Overtime List</span>
      <v-spacer></v-spacer>
      <v-autocomplete            
      label="Year"
      :items="yearList"
      item-text="name"
      item-value="year"
      single-line hide-details 
      v-model="selectedYear" 
      @input="findByYear()"
      clearable    
      ></v-autocomplete>
      <v-spacer></v-spacer>
       <v-autocomplete
        :items="months"
        label="Month"
        item-value="text"
        hide-details
        v-model="selectedMonth"
        @input="findByMonth()"
        clearable
      ></v-autocomplete>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <span style="display:none;">{{serial=serialNumber}}</span>
    <v-data-table
      :headers="headers"
      :items="desserts"
      :pagination.sync="pagination"
      :total-items="totalDesserts"
      :loading="loading"
      
    >
    <template slot="items" slot-scope="props">
            <td class="text-xs-left">{{ ++(props.index) }}</td>
            <td class="text-xs-left">{{ props.item.staff_id }}</td>
            <td class="text-xs-left">{{ props.item.staff_name }}</td>
            <td class="text-xs-left">{{ props.item.days }}</td>
            <td class="text-xs-left">{{ props.item.year }}</td>
            <td class="text-xs-left">{{ props.item.month }}</td>
            <td class="text-xs-left">{{ props.item.overtime }}</td>
            <td class="text-xs-left">{{ props.item.rate }}</td>
            <td class="text-xs-left">{{ props.item.total }}</td>
            
            <td class="justify-center layout px-0">
                <v-btn icon class="mx-0"  @click="editItem(props.item)">
                    <v-icon color="teal">edit</v-icon>
                </v-btn>
                <v-btn icon class="mx-0"  @click="deleteItem(props.index, props.item.id)">
                    <v-icon color="pink">delete</v-icon>
                </v-btn>
            </td>

        </template> 

        <template slot="no-data" class="error">
        <div align="center">No Data Found</div>
      </template>
    </v-data-table>
      <!-- <v-data-table item-key="name" class="elevation-1" loading loading-text="Loading... Please wait"></!--> 
  </v-card>
     </v-container>
     
    </div>
</template>
<script>
const commonService = require('../../../services/common.service');

import {preFix} from '../../../vuex/api'
import overtimeEntryForm from './overtime_entry_form'
import Axios from 'axios'
export default {
    components:{
        overtimeEntryForm
    },
    data: () => ({
      showForm : true,
      valid: true,
      dialog: false,
      dialogEditForm:false,

      selected:[],
      /*------------- Datatable ---------------*/
      serialNumber: 0,
      sort: "",
      queryData: {
        sortBy: "id",
        descending: true,
        page: 1,
        rowsPerPage: 5,
        totalItems: 0,
        search_val: ""
      },

      search: "",
      totalDesserts: 0,
      desserts: [],
      loading: true,
      pagination: {},     
      headers: [
      {
        text: 'Sl#',
        align: 'left',
        sortable: false,
        value: 'id'
      },
      {
        text: 'ID',
        align: 'left',
        sortable: true,
        value: 'staff_id'
      },
      {
        text: 'Name',
        align: 'left',
        sortable: true,
        value: 'staff_name'
      },
      { text: 'Days', align: 'left', value: 'days' },
      { text: 'Year', align: 'left', value: 'year' },
      { text: 'Month', value: 'month' },
      { text: 'Overtime (hour)', value: 'overtime' },
      { text: 'Overtime Rate (BDT/hour)', value: 'rate' },
      { text: 'Total', value: 'total' },
      { text: 'Actions', value: '', align: 'center' },

      
      ],
      items: [],
      SnackbarVal: {
      snackbar: false,
      color: "success",
      message: "",
    },
     formSchema: [
      {
        id: "",
        staff_id: "",
        overtime: "",
        rate: "",
        total: "",
        year: "",
        month: "",
        isCheck: false
      }      
    ],
      
      item: [],
      yearList: [],
      selectedYear:'',
      months: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
      ],
      selectedMonth:'',
      delete_id:'',
      row_index:'',
      dialog2: false,
      snackbar: false,
      color: 'success',
      mode: '',
      timeout: 3000,
      left:'left',
      message: '',
      confirmModel: false,
      select: null,
      instituteShow:true,
    }),

    watch: {
        params: {
          handler() {
            
            this.liveSearch().then(data => {
              this.desserts = data.items;
        this.totalDesserts = data.total;
            });
          },
          deep: true
        },

        userRole: function(){}
      },
    computed: {
      params(nv) {
      return {
        ...this.pagination,
        query: this.search
      };
     },
      userRole() {
                let role = this.$store.getters.get_USER_ROLE_DATA;               
                this.showForm = role.saveButton
                return role;
            },
      getYears(){
          let year = new Date().getFullYear()
          let fetchYear = Array.from({length: year - 1900}, (value, index) => 2010 + index)
          fetchYear.forEach((item) => {
              this.yearList.push({year:item.toString(), name: item.toString()})
          })
        },
    },

    methods: {
    findByYear(){
        this.liveSearch().then(data => {          
          this.desserts = data.items;
        this.totalDesserts = data.total;
      });
    },
    findByMonth(){
        this.liveSearch().then(data => {          
          this.desserts = data.items;
        this.totalDesserts = data.total;
      });
    },
    liveSearch(){
         this.loading = true;
      return new Promise((resolve, reject) => {
        const { sortBy, descending, page, rowsPerPage } = this.pagination;
        let search = this.search.trim().toLowerCase();

        let query_Data = this.queryData;

        (query_Data.sortBy = "id"),
          (query_Data.descending = this.pagination.descending),
          (query_Data.page = this.pagination.page),
          (query_Data.rowsPerPage = this.pagination.rowsPerPage),
          (query_Data.selectedYear = (this.selectedYear) ? this.selectedYear : ''),
          (query_Data.selectedMonth = (this.selectedMonth) ? this.selectedMonth : ''),
          (query_Data.search_val = this.search);

        const serialNumber =
          this.pagination.rowsPerPage * this.pagination.page -
          this.pagination.rowsPerPage;
        this.serialNumber = serialNumber + 1;

        commonService
          .getServerSideData(query_Data, "overtime-search-info-list")
          .then(res => {
            let items = res.data;
            const total = res.totalRecords;
            if (search) {
              items = items.filter(item => {
                return Object.values(item)
                  .join(",")
                  .toLowerCase()
                  .includes(search);
              });
            }

            if (this.pagination.sortBy) {
              items = items.sort((a, b) => {
                const sortA = a[sortBy];
                const sortB = b[sortBy];

                if (descending) {
                  if (sortA < sortB) return 1;
                  if (sortA > sortB) return -1;
                  return 0;
                } else {
                  if (sortA < sortB) return -1;
                  if (sortA > sortB) return 1;
                  return 0;
                }
              });
            }

            setTimeout(() => {
              this.loading = false;
              resolve({
                items,
                total
              });
            }, 300);
          });
      });
        
    },

     getDataFromApi(){  

      commonService.getAllData('overtime_info').then(res => {                                    
        this.items = res.data;
        this.loading = false;
      });

      },

       changeSort (column) {
        if (this.pagination.sortBy === column) {
          this.pagination.descending = !this.pagination.descending
        } else {
          this.pagination.sortBy = column
          this.pagination.descending = false
        }
      },

      validateBeforeSubmit(e) {
        
      },
      reloadData(){
        this.showForm = this.userRole.saveButton;
        this.getDataFromApi()
      
      },

      editItem (item) {
        this.item = item;
        this.showForm = true
        window.scrollTo({ // scroling to top
			    top: 0,
			    left: 100,
			    behavior: "smooth"
			  });
      },

      deleteItem (index,id) {          
        this.row_index = index;
        this.delete_id = id;                
        this.confirmModel = true;
      },

      confirmDelete(row_index,id){                    
        commonService.deleteRow(id, 'overtime_info').then(res => {
              this.items.splice(row_index, 1)
              
              this.confirmModel = false
              this.SnackbarVal.message = res.message;
      this.SnackbarVal.snackbar = true;
              this.reloadData()
        });       
      },

    },

    mounted () {
      this.getDataFromApi();
      this.getYears
    },
}
</script>


// WEBPACK FOOTER //
// src/components/administration/overtime_entry/overtime_entry_list.vue